<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <div class="modal-quit p-20 center">

     <h4 class="flex center mb-10">{{ dictionnary ? dictionnary.templateMenu.titreDelete : ""}}</h4>
     <div class="flex center horizontal">
        <sw-button
        class="button-template-modal-cancel center mr-3"
        :label="dictionnary ? dictionnary.buttons.cancel : ''"
        @click="$emit('close')"
      />
       <sw-button
        class="button-template-modal-delete center  "
        :label="dictionnary ? dictionnary.buttons.supprimer : ''"
        @click="valid($attrs.template)"
      />
     </div>
    </div>
  </sw-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { EventBus, NOTIFICATION_INFO } from '@/model/EventBus'

export default {
  name: 'TemplateModal',
  components: {},
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null
    }
  },
  props: {
   
  },
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
        ...mapActions(['deleteTemplate']),

    async valid(template) {
      
      const result = await this.deleteTemplate(template)
       if (result.status === 200) {
        EventBus.$emit(NOTIFICATION_INFO, { type: 'infos', code: 'removeTemplateSuccess', class: 'info' })
      }
      this.$emit("close")

    }
  },
  watch: {}
}
</script>






// WEBPACK FOOTER //
// src/components/modal/TemplateDeleteModal.vue